export default "__VITE_ASSET__Bkd8tqwO__"